import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gfu-layout__main gfu-layout__main--narrow js-main-content" }
const _hoisted_2 = { class: "gfu-subheading gfu-subheading--main" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_steps_indicator = _resolveComponent("steps-indicator")
  const _component_payment_checkout_header = _resolveComponent("payment-checkout-header")
  const _component_legacy_cart_table = _resolveComponent("legacy-cart-table")
  const _component_base_notificator = _resolveComponent("base-notificator")
  const _component_checkout_return_actions = _resolveComponent("checkout-return-actions")
  const _component_legacy_order_summary_list = _resolveComponent("legacy-order-summary-list")
  const _component_order_payment_options = _resolveComponent("order-payment-options")
  const _component_checkout_footer = _resolveComponent("checkout-footer")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    ($options.hasMoreThanOneStep)
      ? (_openBlock(), _createBlock(_component_steps_indicator, {
          key: 0,
          steps: $options.stepsArray,
          "is-in-admin-mode": false
        }, null, 8 /* PROPS */, ["steps"]))
      : _createCommentVNode("v-if", true),
    _createElementVNode("h1", {
      class: _normalizeClass(['gfu-heading gfu-heading--main', {'_mt-6': !$options.hasMoreThanOneStep}]),
      "data-qa": "page-title"
    }, _toDisplayString(_ctx.Resources.Checkout.CheckoutHeader), 3 /* TEXT, CLASS */),
    _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.Resources.Checkout.CheckoutSubHeader), 1 /* TEXT */),
    _createVNode(_component_box, { class: "_mt-3 _mb-6" }, {
      default: _withCtx(() => [
        _createVNode(_component_payment_checkout_header, _normalizeProps(_guardReactiveProps($options.paymentCheckoutHeaderPropsModel)), null, 16 /* FULL_PROPS */),
        _createVNode(_component_legacy_cart_table, _normalizeProps(_guardReactiveProps($options.cartTableModelFormatted)), null, 16 /* FULL_PROPS */),
        ($options.shouldDisplayNotificator)
          ? (_openBlock(), _createBlock(_component_base_notificator, _mergeProps({ key: 0 }, $props.validationResult, { class: "_my-2" }), null, 16 /* FULL_PROPS */))
          : _createCommentVNode("v-if", true),
        _createVNode(_component_checkout_return_actions, {
          "action-url": $props.backUrl,
          qa: $options.checkoutReturnActionsQa
        }, null, 8 /* PROPS */, ["action-url", "qa"]),
        _createVNode(_component_legacy_order_summary_list, { "order-id": $props.orderID }, null, 8 /* PROPS */, ["order-id"]),
        _createVNode(_component_order_payment_options, _normalizeProps(_guardReactiveProps($props.orderPaymentOptions)), null, 16 /* FULL_PROPS */),
        _createVNode(_component_checkout_footer, { "show-digital-content-info": $props.hasDigitalItems }, null, 8 /* PROPS */, ["show-digital-content-info"])
      ]),
      _: 1 /* STABLE */
    })
  ]))
}